

export const textSize =(value:number)=>{
  return {
    fontSize: value+"px",
    [`@media only screen and (min-width: 1680px)`]: {
        fontSize: (value+2) +"px",
    },
  }
};

export const text_size = (value:number)=>{
  return `
    font-size: ${value}px;
    @media only screen and (min-width: 1680px) {
        font-size: ${value+2}px;
    }`
};